<div class="window__handler" [ngClass]="{ home: hubService.currentLocation === 'home' }" >
  <ng-container *ngIf="!showFullMode && (!isEmbed || allowBackButtonsInEmbed || isChatPage)">
    <breadcrumbs
      #breadcrumbsRef
      *ngIf="showMinimal && currentLocation !== 'home'"
      [showArrows]="showArrowsBreadcrumbs || (isChatPage && isNative)"
      [showBreadcrumbsItems]="!isChatPage"
      [styles]="isChatPage ? { color: 'var(--color-primary)', 'font-size': '16px' } : null"
    >
    </breadcrumbs>
    <collection-header-line
      #collectionHeaderLineRef
      *ngIf="!!currentCollection"
      [collection]="currentCollection"
      [collectionResultData]="collectionsService"
    ></collection-header-line>
    <app-status-badges *ngIf="showMinimal" [isOwnerOrAdmin]="isOwnerOrAdmin"></app-status-badges>
  </ng-container>
  <div
    *ngIf="isEmbed && !embedInline"
    class="embed-header"
    [ngClass]="{ 'embed-header-with-back': hubService.readOnly }"
    [ngStyle]="{ 'justify-content': !isChatPage ? 'space-between' : 'flex-end' }"
  >
    <div class="back-header" *ngIf="(hubService.readOnly$ | async) && !isChatPage">
      <u-icon
        class="back-icon"
        [model]="{ type: 'font', value: 'icon-chevron-left' }"
        [styles]="{ fontSize: '12px' }"
        (click)="goBack()"
        [isBold]="true"
      ></u-icon>
      <div class="header-title">{{ groupName }}</div>
    </div>
    <div class="header-buttons-container">
      @for (button of ACTION_HEADER_BUTTONS; track $index) {
        <u-button
          (onClick)="onActionClick(button.type)"
          [versionNumber]="2"
          [typeElement]="'secondary'"
          [fontIcon]="button.icon"
          [sizeElement]="'extra-small'"
          [iconStyles]="{ fontSize: '13px' }"
          [pTooltip]="button.toolTip"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        >
        </u-button>
      }
    </div>
  </div>
</div>
